const mbxGeocoding = require('@mapbox/mapbox-sdk/services/geocoding');

export const GEOCODE_ADDRESS_ERROR =
  "We can't find this address unfortunately. Please try another one.";

function finiteCoordinate(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (
    typeof value === 'string' &&
    value.trim() !== '' &&
    Number.isFinite(Number(value))
  ) {
    return Number(value);
  }
  return null;
}

/**
 * A geocode is usable when both coordinates are finite.
 * One zero (equator or prime meridian) is a real coordinate.
 * A parsed 0,0 pair is Null Island and is rejected.
 */
export function usableGeocodeCoordinates(lat, lng) {
  const latitude = finiteCoordinate(lat);
  const longitude = finiteCoordinate(lng);
  if (
    latitude === null ||
    longitude === null ||
    (latitude === 0 && longitude === 0)
  ) {
    throw new Error(GEOCODE_ADDRESS_ERROR);
  }
  return { lat: latitude, lng: longitude };
}

const geocode = async data => {
  const geocoding = mbxGeocoding({
    accessToken:
      'pk.eyJ1Ijoia29wdGlvbmFsc29mdHdhcmUiLCJhIjoiY2treDQxdjlqMWdxaTMxbXlyMTc1MjF0aiJ9.nU7bEAZNngBALr03gZOqQg'
  });
  const res = await geocoding
    .forwardGeocode({
      query: `${data.address.street}, ${data.address.city}, ${data.address.state} ${data.address.zip}`,
      limit: 1
    })
    .send();
  const match = res.body;
  const firstResult = match?.features?.[0];
  const [lng, lat] = firstResult?.geometry?.coordinates ?? [null, null];
  return usableGeocodeCoordinates(lat, lng);
};

export default geocode;
